import { Component, OnInit, Input, Output, EventEmitter, ViewEncapsulation, ViewChild, ElementRef, HostListener } from '@angular/core';
import Swal from 'sweetalert2';

@Component({
    selector: 'app-single-request',
    templateUrl: 'request.component.html',
    styleUrls: ['./request.component.css', './request.component.scss'],
    encapsulation: ViewEncapsulation.None
})

export class RequestComponent implements OnInit {

    @ViewChild('optsBtn', { static: false }) optsBtn: ElementRef;

    dashboardFinal: boolean;

    @Input() dashboard: boolean;
    @Input() selectedRequest: any;
    @Input() requestId: number;
    @Input() extrasVisible: boolean;
    @Output() removeButtonClicked: EventEmitter<any> = new EventEmitter<any>();

    selectedExps: Array<String>;

    optionsVisible: Boolean = false;

    allWishes: Array<String>;

    isPrOpen: Boolean = false;
    isWishesOpen: Boolean = false;

    experiencesMappingRestOld = [
        { id: 1, name: 'Leisure', checked: false },
        { id: 2, name: 'Beach & Sun', checked: false },
        { id: 3, name: 'Relax', checked: false },
        { id: 4, name: 'Family', checked: false },
        { id: 5, name: 'Budget / Save money', checked: false },
        { id: 6, name: 'Luxury Holidays', checked: false },
        { id: 7, name: 'Local Gastronomy', checked: false },
        { id: 8, name: 'Local Culture', checked: false },
        { id: 9, name: 'Experience Local Way Of Life', checked: false },
        { id: 10, name: 'Spa & Wellness', checked: false },
        { id: 11, name: 'Beauty Services', checked: false },
        { id: 12, name: 'Child Care', checked: false },
        { id: 13, name: 'Wedding', checked: false },
        { id: 14, name: 'Anniversary / Romance', checked: false },
        { id: 15, name: 'Business travel', checked: false },
        { id: 16, name: 'Conference', checked: false },
        { id: 17, name: 'Exhibitions', checked: false },
        { id: 18, name: 'Nightlife', checked: false },
        { id: 19, name: 'Car - Moto rental services', checked: false },
        { id: 20, name: 'Taxi - Shuttle service', checked: false },
        { id: 21, name: 'Tours', checked: false },
        { id: 22, name: 'Watersports', checked: false },
        { id: 23, name: 'Outdoor activities / sports', checked: false },
        { id: 24, name: 'Archeological sights / Landmarks', checked: false },
        { id: 25, name: 'Nature / Parks', checked: false },
        { id: 26, name: 'Shopping', checked: false },
        { id: 27, name: 'Events / Concerts / Shows', checked: false },
        { id: 28, name: 'Classes / Workshops', checked: false },
        { id: 29, name: 'Agricultural Experience', checked: false },
        { id: 30, name: 'Casino & Gambling', checked: false },
        { id: 31, name: 'Zoos / Aquariums / Amusement Park', checked: false },
        { id: 32, name: 'Medical Tourism', checked: false },
        { id: 33, name: 'Safe Stay', checked: false },
        { id: 34, name: 'Party Allowed', checked: false },
        { id: 35, name: 'Pets Allowed', checked: false }
    ];
    experiencesMappingRestNew = [
        { id: 7, name: 'Love to explore the local cuisine', checked: false, position: 1 },
        { id: 35, name: 'Looking for pet-friendly accommondation', checked: false, position: 2 },
        { id: 19, name: 'Looking to rent a car', checked: false, position: 3 },
        { id: 33, name: 'Concerned about COVID-19 safety protocols', checked: false, position: 4 },
        { id: 14, name: 'Celebrating our time together', checked: false, position: 5 },
        { id: 10, name: 'From massage to beauty services, you name it', checked: false, position: 6 },
        { id: 15, name: 'Wanting a workspace, got some work to do', checked: false, position: 7 },
        { id: 4, name: 'Want to spend precious time with my family', checked: false, position: 8 },
        { id: 12, name: 'Would love for child care or nanny services', checked: false, position: 9 },
        { id: 34, name: 'Looking for a place to host a venue', checked: false, position: 10 },
        { id: 20, name: 'Would love to be transfered from and to the airport', checked: false, position: 11 },
        { id: 6, name: 'Looking for high-end luxurious experiences', checked: false, position: 12 },
        { id: 13, name: 'Host our guests and/or our wedding party', checked: false, position: 13 },
        { id: 8, name: 'Want to experience the local way of life', checked: false, position: 14 },
        { id: 24, name: 'Want to explore the landmarks, sites and local history ', checked: false, position: 15 },
        { id: 5, name: 'On a budget trying to save money', checked: false, position: 16 },
        { id: 2, name: 'I want to enjoy the warm sun and the golden beaches', checked: false, position: 17 },
        { id: 3, name: 'My ideal scenario is to just lay back and relax', checked: false, position: 18 }
    ];


    showOptsForRemove: Boolean = false;

    constructor() { }

    @HostListener('document:click', ['$event'])
    clickout(event) {
        if (!this.optsBtn.nativeElement.contains(event.target)) {
            if (this.optionsVisible) {
                this.optionsVisible = false;
            }
        }
    }

    ngOnInit() {
        this.allWishes = new Array<String>();
        this.selectedExps = new Array<String>();
        this.selectedRequest.fromDate = new Date(this.selectedRequest.fromDate.getTime() +
            Math.abs(this.selectedRequest.fromDate.getTimezoneOffset() * 60000));
        this.selectedRequest.toDate = new Date(this.selectedRequest.toDate.getTime() +
            Math.abs(this.selectedRequest.toDate.getTimezoneOffset() * 60000));
        const split = this.selectedRequest.exclusiveCategories.toString().split(',');
        this.experiencesMappingRestOld.forEach(exp => {
            for (let i = 0; i < split.length; i++) {
                console.log(split[i].toString().trim() + '--' + exp.name);
                if (exp.name === split[i].toString().trim()) {
                    this.selectedExps.push(exp.id.toString());
                }
            }
        });
        this.experiencesMappingRestNew.forEach(exp => {
            for (let i = 0; i < this.selectedExps.length; i++) {
                if (exp.id.toString() === this.selectedExps[i]) {
                    this.allWishes.push(exp.name);
                }
            }
        });
        if (this.dashboard === true) {
            this.dashboardFinal = true;
        } else {
            this.dashboardFinal = false;
        }
        if (this.selectedRequest.accommodationtype === 0) {
            this.selectedRequest.accommodationtype = 'Villa';
        } else if (this.selectedRequest.accommodationtype === 1) {
            this.selectedRequest.accommodationtype = 'Apartment';
        } else {
            this.selectedRequest.accommodationtype = 'Villa & Apartment';
        }
    }

    removeRequest() {
        this.removeButtonClicked.emit(this.requestId - 1);
        console.log('I am about to remove my request');
    }

    showOpts() {
        this.showOptsForRemove = !this.showOptsForRemove;
    }

    handleRemoveReq() {
        Swal.fire({
            title: 'Are you sure you want to delete this request?',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Yes',
        }).then((result) => {
            if (result.isConfirmed) {
                this.removeRequest();
            }
        });
    }

    showReqOpts() {
        this.optionsVisible = !this.optionsVisible;
    }

    isMobile() {
        const w = window.innerWidth;
        if (w < 992) {
            return true;
        }

        return false;
    }
}
